module.exports = __webpack_public_path__ + "img/right-tree.430e98db.png";